import React from "react";
import PropTypes from "prop-types";

import { DEFAULT_CARD_HEIGHT } from "config/constants";
import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

export default function SectionStream(props) {
  return (
    <SectionStreamWrapper {...props} slug={props.match.params.section}>
      {({ streamParams }) => {
        return (
          <>
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
            />
          </>
        );
      }}
    </SectionStreamWrapper>
  );
}

SectionStream.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string.isRequired,
    }),
  }),
};
